import React from "react";
import { Autocomplete, TextField, Grid, Button } from "@mui/material";

export default function DailyReports({
  setdailyReports,
  setSelectedVisitorTypeId,
  handleFilter,
  visitorTypeOptions,
}) {
  return (
    <div>
      <Grid container spacing={1} sx={{ mb: 2, alignItems: "stretch" }}>
        <Grid item xs={8}>
          <Autocomplete
            id="visitor-type"
            options={visitorTypeOptions}
            getOptionLabel={(option) => option?.name || ""}
            size="small"
            onChange={(e, value) => {
              setSelectedVisitorTypeId(value?.id || null);
            }}
            sx={{
              "& .MuiAutocomplete-inputRoot": {
                minHeight: "55px",
              },
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select visitor type"
                InputLabelProps={{
                  style: { color: "#929191", fontSize: 14 },
                }}
                name="visitor_type_id"
              />
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <Button
            variant="contained"
            color="primary"
            onClick={handleFilter}
            fullWidth
            size="small"
            sx={{ height: "55px" }}
          >
            Confirm
          </Button>
        </Grid>
      </Grid>
    </div>
  );
}
